// Meta Pixel helpers: Manual Advanced Matching + per-item contents.
//
// Advanced Matching lets Meta attribute far more conversions (their own
// diagnostic reports ~54% more for advertisers who send Email on Purchase).
// The browser pixel hashes these values itself, so we pass them in plain —
// never hash them here, or matching breaks.

export const PIXEL_ID = '1252262830433503';

const clean = (v) => (v === undefined || v === null ? '' : String(v).trim().toLowerCase());
const digitsOnly = (v) => String(v === undefined || v === null ? '' : v).replace(/\D/g, '');
const lettersOnly = (v) => clean(v).replace(/[^a-z؀-ۿ]/g, '');

// Tunisian numbers are usually 8 local digits; Meta wants the country code.
export const normalizePhone = (raw) => {
  let d = digitsOnly(raw).replace(/^0+/, '');
  if (!d) return '';
  if (d.length === 8) d = '216' + d;
  return d;
};

/**
 * Re-init the pixel with the customer's details so subsequent events (Purchase)
 * carry Advanced Matching parameters. Safe to call repeatedly.
 */
export const setPixelUserData = ({ name, email, phone, city, state, zip } = {}) => {
  if (typeof window === 'undefined' || !window.fbq) return;

  const parts = clean(name).split(/\s+/).filter(Boolean);
  const data = {};

  if (email) data.em = clean(email);
  const ph = normalizePhone(phone);
  if (ph) data.ph = ph;
  if (parts[0]) data.fn = lettersOnly(parts[0]);
  if (parts.length > 1) data.ln = lettersOnly(parts.slice(1).join(' '));
  if (city) data.ct = clean(city).replace(/\s/g, '');
  if (state) data.st = clean(state).replace(/\s/g, '');
  if (zip) data.zp = digitsOnly(zip);
  data.country = 'tn';

  if (Object.keys(data).length > 0) {
    window.fbq('init', PIXEL_ID, data);
  }
};

/**
 * Per-item price/quantity breakdown for Purchase/AddToCart. Sending this — not
 * only a single `value` — is what Meta's "fix price data" diagnostic asks for.
 */
export const buildContents = (items = []) =>
  (items || []).map((i) => ({
    id: String(i.id ?? i.product ?? i._id ?? ''),
    quantity: Number(i.quantity ?? i.amount) || 1,
    item_price: Number(i.price) || 0,
  }));

export const sumItems = (contents = []) =>
  contents.reduce((n, c) => n + (Number(c.quantity) || 1), 0);

const readCookie = (name) => {
  if (typeof document === 'undefined') return undefined;
  const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return m ? decodeURIComponent(m[2]) : undefined;
};

/**
 * The pixel's click/browser cookies. These are the strongest match signals for
 * server-side (Conversions API) events, so forward them with the order.
 * `fbc` is rebuilt from the fbclid query param when the cookie isn't set yet.
 */
export const getFbCookies = () => {
  const fbp = readCookie('_fbp');
  let fbc = readCookie('_fbc');

  if (!fbc && typeof window !== 'undefined') {
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (fbclid) fbc = `fb.1.${Date.now()}.${fbclid}`;
  }

  return { fbp, fbc };
};

export const getEventSourceUrl = () =>
  typeof window !== 'undefined' ? window.location.href : undefined;

/** Fields to merge into the create-order body so the server can build a
 *  complete Conversions API event. */
export const metaOrderFields = () => ({
  ...getFbCookies(),
  eventSourceUrl: getEventSourceUrl(),
});
